import React from "react";
import { ReviewReplyForm } from "ComponentsUI/Reviews";
import { PaddingBottom } from "ComponentsUI/Spacings";
import LoginLogic from "HOC/LoginLogic";
import Button from "ComponentsUI/Button";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

@withRouter
@inject("ApplicationModel")
@observer
export default class ReviewReplyFormContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			comment: "",
			error: "",
		};
	}

	changeComment(event) {
		this.setState({
			comment: event.target.value,
			error: "",
		});
	}

	sendComment() {
		const sendingStore = this.props.ApplicationModel.sendingStore;
		const reviewId = this.props.match.params.reviewId || this.props.reviewId;
		let text = this.props.ApplicationModel.text;
		let data = {
			type: "comment",
			text: this.state.comment,
		};
		let res = sendingStore
			.onSendComment(reviewId, data)
			.then((data) => {
				if (data.errors) {
					let errorText = data.errors.text.list.map((v) => v.message);
					this.setState({
						error: errorText.join(","),
					});
				} else {
					this.setState({
						comment: "",
						error: "",
					});
					this.props.succesfullyReplyCallback(data.data);
				}
			})
			.catch((data) => {
				console.warn("catch", data);
				this.setState({
					error: text.ERROR_SENDING_COMMENT,
				});
			});
		return res;
	}

	render() {
		let authModel = this.props.ApplicationModel.newAuthModel;
		let text = this.props.ApplicationModel.text;
		let userIsAuth = !!authModel.user && !!authModel.user.id;
		let anonimousButton = (
			<Button
				onClick={() => this.sendComment()}
				transparent={true}
				fullWidth={true}
				noPaddings={true}
				size="middle"
				status="simpleText"
			>
				{text.SEND_ANONIM_COMMENT}
			</Button>
		);
		return (
			<PaddingBottom>
				<LoginLogic addButton={anonimousButton}>
					<ReviewReplyForm
						text={text}
						userIsAuth={userIsAuth}
						sendComment={() => this.sendComment()}
						comment={this.state.comment}
						changeComment={(e) => this.changeComment(e)}
						error={this.state.error}
					/>
				</LoginLogic>
			</PaddingBottom>
		);
	}
}
